'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useRef } from 'react';
import type { SelfStep } from '../types';
export const PARAM_ETAPA = 'etapa';
const STEP_TO_SLUG: Record<SelfStep, string | null> = {
  landing: null,
  objetivo: 'objetivo',
  perfil: 'perfil',
  parametros: 'parametros',
  revisao: 'revisao',
  pagamento: 'pagamento',
  errorPayment: 'pagamento',
  waitingPayment: 'aguardando',
  terms: 'termos',
  success: 'sucesso'
};
const SLUG_TO_STEP: Record<string, SelfStep> = {
  objetivo: 'objetivo',
  perfil: 'perfil',
  parametros: 'parametros',
  revisao: 'revisao',
  pagamento: 'pagamento',
  aguardando: 'waitingPayment',
  termos: 'terms',
  sucesso: 'success'
};
export const resolverEtapa = (slug: string | null): SelfStep => slug ? SLUG_TO_STEP[slug] ?? 'landing' : 'landing';
const ETAPAS_QUE_EMPILHAM_HISTORICO: readonly SelfStep[] = ['terms'];
export const useSelfStepUrl = (step, irParaEtapa) => {
  const $ = _c(12);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get(PARAM_ETAPA);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const slugAtual = t0;
  const stepAnteriorRef = useRef(null);
  const slugAnteriorRef = useRef(null);
  let t1;
  let t2;
  if ($[2] !== irParaEtapa || $[3] !== pathname || $[4] !== router || $[5] !== searchParams || $[6] !== slugAtual || $[7] !== step) {
    t1 = () => {
      const primeiraExecucao = stepAnteriorRef.current === null;
      const stepAnterior = stepAnteriorRef.current;
      const slugAnterior = slugAnteriorRef.current;
      stepAnteriorRef.current = step;
      slugAnteriorRef.current = slugAtual;
      if (primeiraExecucao) {
        const etapaInicial = resolverEtapa(slugAtual);
        if (etapaInicial !== step) {
          irParaEtapa(etapaInicial);
        }
        return;
      }
      const slugMudou = slugAnterior !== slugAtual;
      const stepMudou = stepAnterior !== step;
      if (slugMudou && !stepMudou) {
        if (STEP_TO_SLUG[step] !== slugAtual) {
          irParaEtapa(resolverEtapa(slugAtual));
        }
        return;
      }
      if (!stepMudou) {
        return;
      }
      const slugDesejado = STEP_TO_SLUG[step];
      if (slugDesejado === slugAtual) {
        return;
      }
      const params = new URLSearchParams(searchParams.toString());
      if (slugDesejado) {
        params.set(PARAM_ETAPA, slugDesejado);
      } else {
        params.delete(PARAM_ETAPA);
      }
      const query = params.toString();
      const url = query ? `${pathname}?${query}` : pathname;
      if (ETAPAS_QUE_EMPILHAM_HISTORICO.includes(step)) {
        router.push(url, {
          scroll: false
        });
        return;
      }
      router.replace(url, {
        scroll: false
      });
    };
    t2 = [step, slugAtual, searchParams, pathname, router, irParaEtapa];
    $[2] = irParaEtapa;
    $[3] = pathname;
    $[4] = router;
    $[5] = searchParams;
    $[6] = slugAtual;
    $[7] = step;
    $[8] = t1;
    $[9] = t2;
  } else {
    t1 = $[8];
    t2 = $[9];
  }
  useEffect(t1, t2);
  let t3;
  if ($[10] !== router) {
    t3 = () => router.back();
    $[10] = router;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};